import { selectUserProfile } from '../features/common/auth/auth-slice';
import { Roles } from '../model/common/Roles';
import { useAppSelector } from '../store/hooks';

/**
 * Checks whether the current user has at least one of the allowed local roles.
 */
export function useHasRole(allowedRoles: Roles[]): boolean {
  const userProfile = useAppSelector(selectUserProfile);
  return !!userProfile?.localRoles.some((role) => allowedRoles.includes(role as Roles));
}
